// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__KxvH1","info":"Note_info__1Ex1k","note":"Note_note__38rq4","actions":"Note_actions__do5Y1"};